export default __webpack_public_path__ + "static/media/incubator-info-img.c6ccd040.svg";